// --------------------------------------------------------------------------
// Components of CPT page including their logical connections.
// --------------------------------------------------------------------------

import { Flex } from "@chakra-ui/react";
import HeaderCPT from './components/HeaderCPT';
import BodyCPT from './components/BodyCPT';


const CPTPage: React.FC = () => {
  return(
    <Flex flexDirection="column" height="100vh">
      <HeaderCPT />
      <BodyCPT />
    </Flex>
  );
};

export default CPTPage;